import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, IconButton, Tab, Tabs } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  columnData,
  getColorChange,
  ManageUserColumnData,
} from "../../common/constants/gridRowColumn";
import {
  useCompany,
  useDealer,
  useFleetList,
  useModel,
  useMovableColumn,
  useNewVehicle,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
} from "../../common/hooks";
import { DeleteDialog } from "../../components/DeleteDialog";
import { layoutStyle } from "../layout-ui/style";
import { TruckLoader } from "./truckLoader";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  getCompanyId,
  getDefaultColDef,
  isAdmin,
  onGridReady,
} from "../../common/constants/commonFunction";
import { sidebarMenu } from "../../common/constants/commonFunction";
import { FleetCsvUpload } from "../../components/FleetCsvUpload";
import { FleetHeaderButton } from "../../components/FleetHeaderButton";
import {
  CustomTabPanel,
  a11yProps,
} from "../../components/FleetTabPanelCustom";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import { SpeakToTextButton } from "../../common/services/SpeakToTextButton";
import { localStorageItemNames } from "../../common/constants";
import { set } from "react-hook-form";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { PopupBlock } from "../../components/PopupBlock";
import { onSortChanged } from "../../common/utils/sortingColumn";

export const FleetList = () => {
  const classes = layoutStyle();
  const [columnFinal, setColumnFinal] = useState([]);
  const [value, setValue] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    fleetList,
    getFleetListApi,
    setEditData,
    setTotalCount,
    deletFleetListByIdApi,
    loading,
    multipleFleetDeleteApi,
    setFleetList,
    requireFields,
  } = useFleetList();
  const {
    setSelectedRow,
    setNewRowData,
    selectedRow,
    newRowData,
    setNewRowIndexData,
  } = useModel();
  const [page, setPage] = useState({ pageSize: 10000, page: 0 });
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteValue, setDeleteValue] = useState();
  const [addButtonDisabled, setAddButtonDisabled] = useState(false);
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const [mpgNull, setMpgNull] = useState([]);
  const [companyId, setCompanyId] = useState();
  const [file, setFile] = useState();
  const [rows, setRows] = useState([]);
  const {
    fleetUpload,
    errorMessage,
    setErrorMessage,
    companyDealerId,
    setFleetUpload,
    setNewFleetNo,
    setMatchDealerName,
  } = useDealer();
  const userType = localStorage.getItem("type");
  const {
    setSelectedNav,
    columnChange,
    setColumnChange,
    popupBlock,
    setPopupBlock,
    setSidebarColumnPopup,
  } = useUser();
  const { state } = useLocation();
  const navigation = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [rowDataCSV, setRowDataCsv] = useState([]);
  const [originalColumn, setOriginalColumn] = useState(false);
  const { setToastClose, setNewVehicle } = useNewVehicle();
  const [gridApi, setGridApi] = useState(null);
  const { setReplacementList } = useReplacement();
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
    sortedColumn,
    setSortedColumn,
  } = useMovableColumn();
  const {
    fleetPagination,
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();

  const handleClose = () => {
    setOpen(false);
    setValue(0);
    setRows([]);
    setNewRowData([]);
    setFile(null);
    setErrorMessage("");
    setAddButtonDisabled(false);
    setMatchDealerName([]);
  };

  useEffect(() => {
    if (companyNameHeader) {
      let companyValue = getCompanyId(userType, companyNameHeader);
      setCompanyId(companyValue);
    }
  }, [companyNameHeader]);

  useEffect(() => {
    const searchData = fleetList?.filter((fleet) =>
      fleet?.fleetNo?.toLowerCase().includes(searchValue?.toLowerCase())
    );
    if (searchValue) {
      setRowDataFinal([...searchData]);
    } else if (fleetList?.length > 0) {
      setRowDataFinal([...fleetList]);
    } else {
      setRowDataFinal([]);
    }
  }, [searchValue, fleetList]);

  const defaultColDef = useMemo(() => getDefaultColDef(), []);

  useEffect(() => {
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fleetList,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    setErrorMessage("");
    setToastClose(false);
    setNewRowIndexData(null);
    setNewVehicle([]);
    setReplacementList([]);
    setSidebarColumnPopup("");
    setPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
    setFundingPagination(0);
  }, []);

  useEffect(() => {
    let companyValue = getCompanyId(userType, companyNameHeader);
    setColumnChange(false);
    setPopupBlock(false);
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fleetList,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    if (companyValue && dealerNameHeader) {
      getFleetListApi({
        limit: page.pageSize,
        offset: page.page,
        filter: {},
        companyId: companyValue,
        dealerId: dealerNameHeader?.id,
      });
    } else {
      setRowDataFinal([]);
      setFleetList([]);
      setMpgNull([]);
    }
  }, [fleetUpload, companyNameHeader, dealerNameHeader, companyDealerId]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) {
      setOpen(true);
    }
  };

  useEffect(() => {
    if (sortedColumn?.length > 0) {
      const dataFinal = [];

      // Step 1: Add matching fleet numbers in the correct sequence
      sortedColumn.forEach((fleetNo) => {
        const match = fleetList.find((item) => item.fleetNo === fleetNo);
        if (match) dataFinal.push(match);
      });

      // Step 2: Append remaining fleet numbers (not in sortedColumn)
      const remainingData = fleetList.filter(
        (item) => !sortedColumn.includes(item.fleetNo)
      );

      dataFinal.push(...remainingData);
      setRowDataFinal([...dataFinal]);
    } else if (state?.data) {
      setRowDataFinal([...state.data]);
      setRows([...state.data]);
      setNewRowData([...state.data]);
    } else {
      if (fleetList?.length > 0) {
        let rowsMpg = [];
        fleetList?.map((items) => {
          if (items?.mpg === 0) {
            rowsMpg.push(items?.fleetNo);
          }
        });
        setMpgNull(rowsMpg);
        setRowDataFinal([...fleetList]);
      } else {
        setRowDataFinal([]);
      }
    }
  }, [fleetList, state]);

  useEffect(() => {
    if (errorMessage == "empty") {
      setTotalCount(fleetList?.length);
      handleClose();
      setRows([]);
      setNewRowData([]);
      setFleetUpload(false);
    } else if (errorMessage) {
      // showToast(errorMessage)
    }
  }, [errorMessage]);

  const handleEditButton = (params) => {
    setEditData(params);
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
        data: params,
      },
    });
  };

  const onCellClicked = (event) => {
    let checkField = checkFieldColumn(event);
    if (checkField) {
      handleEditButton(event?.data);
    }
  };

  const handleDeleteButton = async (values) => {
    const fleetId = values?.fleetId
      ? [values?.fleetId]
      : values.map((item) => item?.fleetId);
    setDeleteOpen(true);
    if (Array.isArray(fleetId)) {
      setDeleteValue(fleetId);
    } else {
      setDeleteValue({ fleetId });
    }
  };

  const handleDelete = async () => {
    setDeleteOpen(false);
    let dealerId = dealerNameHeader?.id;
    if (Array.isArray(deleteValue)) {
      const ids = deleteValue;
      let payload = { ids, companyId, dealerId };
      await multipleFleetDeleteApi(payload);
    } else {
      let payload = {
        ids: deleteValue,
        companyId: companyId,
        dealerId: dealerId,
      };
      await multipleFleetDeleteApi(payload);
    }
    setDeleteValue(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNext = (event) => {
    if (columnChange) {
      setPopupBlock(true);
    } else {
      setSelectedNav(sidebarMenu.replacement);
      navigation("/replacement-schedule");
    }
  };

  const handleOnClose = () => {
    setAnchorEl(null);
  };

  const handleRowSelection = (event) => {
    setFleetPagination(event?.api?.paginationGetCurrentPage());
    setSelectedRows(event.api.getSelectedNodes().map((node) => node.data));
    setSelectedRow(event.api.getSelectedNodes().map((node) => node.data));
  };

  useEffect(() => {
    setEditData({});
    setNewFleetNo(null);
  }, []);

  useEffect(() => {
    if (rowDataCSV?.length > 0) {
      setRows(rowDataCSV);
      setNewRowData(rowDataCSV);
    } else {
      setRows([]);
      setNewRowData([]);
    }
  }, [rowDataCSV]);

  useEffect(() => {
    if (
      requireFields?.length == 0 &&
      columnFinal?.length > 0 &&
      mpgNull?.length == 0
    ) {
      movableColumnData?.map((item) => {
        item["cellStyle"] = { background: "white", color: "black" };
      });
      setColumnFinal([...movableColumnData]);
    } else {
      // const actionColumn = actionColumnFunction({
      //   selectedRows: selectedRows,
      //   handleEditButton: handleEditButton,
      //   handleDeleteButton: handleDeleteButton,
      //   deleteButton: true,
      // });
      // movableColumnData?.map((items) => {
      //   items["cellStyle"] = (params) => getColorChange(params);
      // });
      setColumnFinal([...movableColumnData]);
    }
  }, [requireFields, movableColumnData, mpgNull]);
  const clearAllFilters = () => {
    // Clear all filters in the grid
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };

  useEffect(() => {
    if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      if (sortableColumnData?.length > 0) {
        columnParse?.map((item) => {
          if (
            item.field === sortableColumnData[0].sortedColumn &&
            sortableColumnData[0].pageName === PageNameConstant.fleetList
          ) {
            item["sort"] = sortableColumnData[0].direction;
          } else {
            item["sort"] = null;
          }
        });
      }
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: isAdmin(),
      });
      const filteredColumns = columnParse.filter(
        (col) => col.field !== "action"
      );
      filteredColumns?.map((items) => {
        items["cellStyle"] = (params) => getColorChange(params);
      });
      setMovableColumnData([...filteredColumns, actionColumn]);
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: isAdmin(),
      });
      columnData?.map((items) => {
        items["cellStyle"] = (params) => getColorChange(params);
      });
      setMovableColumnData([checkbox, ...columnData, actionColumn]);
    }
  }, [columnData, movableColumn]);
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (fleetPagination && gridRef?.current?.api) {
      gridRef?.current?.api?.paginationGoToPage(fleetPagination);
    }
  }, [fleetPagination, rowDataFinal]);
  return (
    <Box className={classes.mainFleetContent}>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }} p={0}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              sx={{ textTransform: "capitalize", fontWeight: 600 }}
              label="Fleet List"
              {...a11yProps(0)}
            />
            <Tab
              sx={{ textTransform: "capitalize", fontWeight: 600 }}
              label="Fleet Upload CSV / XLSX"
              {...a11yProps(1)}
            />
            <div className={classes.notediv}>
              <div className={classes.noteContain}>
                {/* <div className={classes.speakToText}>
                  <SpeakToTextButton
                    value={
                      "Red color in grid is for MPG not found in Government website, Yellow color in grid is for Vehicle Model closest match"
                    }
                  />
                </div> */}
              </div>
              <div className={classes.noteContain}>
                <div className={classes.redbox}> </div>&nbsp;MPG not found in
                Government website.
              </div>
              <div className={classes.noteContain}>
                <div className={classes.yellowbox}> </div>&nbsp;Vehicle Model
                -closest match used.
              </div>
            </div>
          </Tabs>
        </Box>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Box className={classes.gridContantFleetListPage}>
          <Box>
            <span
              style={
                mpgNull?.length > 0
                  ? { color: "red" }
                  : { color: "transperent" }
              }
            >
              {mpgNull &&
                mpgNull?.length > 0 &&
                "MPG value is required for following fleets: "}
              {mpgNull &&
                mpgNull?.length > 0 &&
                mpgNull?.map((item) => {
                  return <span key={item}>{item ? item + " " : ""}</span>;
                })}
            </span>
          </Box>
          <FleetHeaderButton
            handleNext={handleNext}
            handleClick={handleClick}
            selectedRows={selectedRows}
            setSearchValue={setSearchValue}
            anchorEl={anchorEl}
            handleOnClose={handleOnClose}
            handleDeleteButton={handleDeleteButton}
            companyId={companyId}
            setSelectedRows={setSelectedRows}
            rowDataFinal={rowDataFinal}
            clearAllFilters={clearAllFilters}
            columnChange={columnChange}
            movableColumnData={movableColumnData}
            setMovableColumnData={setMovableColumnData}
            movableColumn={movableColumn}
            updateViewMovableColumn={updateViewMovableColumn}
            createMovableColumn={createMovableColumn}
            setColumnChange={setColumnChange}
            gridRef={gridRef}
            columnFinal={columnFinal}
            setSortedColumn={setSortedColumn}
            setColumnFinal={setColumnFinal}
            sortableColumnData={sortableColumnData}
            createSortableColumn={createSortableColumn}
            updateViewSortableColumn={updateViewSortableColumn}
            pageName={PageNameConstant.fleetList}
            mpgNull={mpgNull}
          />
          {loading ? (
            <TruckLoader />
          ) : (
            <AgGridReact
              ref={gridRef}
              className="ag-theme-quartz"
              onRowSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRows = rowDataFinal.filter((row) =>
                  selectedIDs.has(row.id)
                );
                setSelectedRows(selectedRows);
              }}
              rowSelection="multiple"
              suppressRowClickSelection
              onColumnMoved={(event) => handleColumnChange(event)}
              pagination={true}
              rowData={rowDataFinal}
              defaultColDef={defaultColDef}
              checkboxSelection
              columnDefs={columnFinal}
              onSelectionChanged={handleRowSelection}
              onCellClicked={onCellClicked}
              onGridReady={(params) => onGridReady(params, setGridApi)}
            />
          )}
        </Box>
      </CustomTabPanel>
      {open && (
        <FleetCsvUpload
          handleClose={handleClose}
          open={open}
          classes={classes}
          defaultColDef={defaultColDef}
          handleRowSelection={handleRowSelection}
          addButtonDisabled={addButtonDisabled}
          setAddButtonDisabled={setAddButtonDisabled}
          setRowDataCsv={setRowDataCsv}
          columnFinal={columnFinal}
          newRowData={newRowData}
          setRows={setRows}
          setFile={setFile}
          file={file}
        />
      )}
      {deleteOpen && (
        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          deleteApi={() => handleDelete()}
        />
      )}
      {popupBlock && (
        <PopupBlock
          open={popupBlock}
          setOpen={() => setPopupBlock(false)}
          navigationRouteNext={"/replacement-schedule"}
          selectedNavStyle={sidebarMenu.replacement}
          columnChangeData={movableColumnData}
          pageName={PageNameConstant.fleetList}
        />
      )}
    </Box>
  );
};
